'use strict';

angular.module('cgmemApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('authenticated.accountView', {
        url: '/accounts/:id',
        templateUrl: 'app/accountView/accountView.html',
        controller: 'AccountViewCtrl',
        params: {
          previousState: ""
        },
				sp: {
					authenticate: true
				}
      })
  });